//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import Theme from '@/listing-app/mixins/Theme'

export default {
	name: "Range",
	mixins: [Theme],
  props: ["data"],
	computed: {
		...mapGetters(["read"]),
		number: {
			get() {
				return this.read("filters")[this.data.ID].value
			},
			set(val) {
				let filter = this.data.ID
				let value = val

				this.set({muta: 'filters', data: { filter, value }})
			}
		}
	},
	methods: {
		...mapActions(["set"]),
		init() {
			if (!this.read("filters").hasOwnProperty(this.data.ID)) {
				let filter = this.data.ID
				let value = this.data.Values.Max

				this.set({muta: 'filters', data: { filter, value }})
			}
		},
		jump(e, max, min) {
			if ((e.code == "ArrowRight" || e.code == "ArrowLeft")&& e.shiftKey) {
				e.preventDefault()
				let number
				if (e.code == "ArrowRight" && e.shiftKey) {
					number = parseInt(this.number) + 99
				}
				else if (e.code == "ArrowLeft" && e.shiftKey) {
					number = parseInt(this.number) - 99
				}

				number = number > max ? max : number
				number = number < min ? min : number
				this.number = number
			}
		},
		format(val) {
			val = parseInt(val).toLocaleString()
			return val
		}
	},
	created() {
		this.init()
	}
}
